/**
 * @generated SignedSource<<f0f2116637caf4d70c85986583cdf45c>>
 * @relayHash 1dd0f4fa67e936e37aa78ff1b8f233bc
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID e8bfcb2fd4ca60cab5a228217932ed9db4d79fb1cdde8dfa6c2c662b15f0e3ec

import type { ConcreteRequest, Mutation } from 'relay-runtime';
export type JiraIssueSearchAggregationFunction = "ROLLUP" | "%future added value";
export type JiraSoftwareIssueSearchCustomInputContext = "BACKLOG" | "BOARD" | "NONE" | "%future added value";
export type JiraDiscardUserIssueSearchConfigInput = {
  viewId: string;
};
export type JiraIssueSearchInput = {
  childIssuesInput?: JiraIssueSearchChildIssuesInput | null | undefined;
  customInput?: JiraIssueSearchCustomInput | null | undefined;
  filterId?: string | null | undefined;
  jql?: string | null | undefined;
  searchWithLastUsedJql?: boolean | null | undefined;
};
export type JiraIssueSearchChildIssuesInput = {
  filterByProjectKeys?: ReadonlyArray<string> | null | undefined;
  filterId?: string | null | undefined;
  jql?: string | null | undefined;
  namespace?: string | null | undefined;
  parentIssueKey: string;
  viewId?: string | null | undefined;
};
export type JiraIssueSearchCustomInput = {
  jiraSoftwareInput?: JiraSoftwareIssueSearchCustomInput | null | undefined;
  jiraTimelineInput?: JiraTimelineIssueSearchCustomInput | null | undefined;
};
export type JiraSoftwareIssueSearchCustomInput = {
  additionalJql?: string | null | undefined;
  context?: JiraSoftwareIssueSearchCustomInputContext | null | undefined;
  jiraEntityId: string;
};
export type JiraTimelineIssueSearchCustomInput = {
  additionalJql?: string | null | undefined;
  boardId: string;
  customFilterIds?: ReadonlyArray<string> | null | undefined;
  quickFilterIds?: ReadonlyArray<string> | null | undefined;
};
export type JiraIssueSearchSettings = {
  groupBy?: string | null | undefined;
  hideDone?: boolean | null | undefined;
  hierarchyEnabled?: boolean | null | undefined;
  jql?: string | null | undefined;
};
export type JiraIssueSearchStaticViewInput = {
  aggregationConfig?: JiraIssueSearchAggregationConfigInput | null | undefined;
  isGroupingEnabled?: boolean | null | undefined;
  isHideDoneEnabled?: boolean | null | undefined;
  isHierarchyEnabled?: boolean | null | undefined;
};
export type JiraIssueSearchAggregationConfigInput = {
  aggregationFields?: ReadonlyArray<JiraIssueSearchFieldAggregationInput> | null | undefined;
  canEnableAggregation?: boolean | null | undefined;
};
export type JiraIssueSearchFieldAggregationInput = {
  aggregationFunction?: JiraIssueSearchAggregationFunction | null | undefined;
  fieldId?: string | null | undefined;
  isEnabled?: boolean | null | undefined;
};
export type SaveResetViewSettingsButtonUIDiscardSettingsMutation$variables = {
  groupBy?: string | null | undefined;
  input: JiraDiscardUserIssueSearchConfigInput;
  issueSearchInput?: JiraIssueSearchInput | null | undefined;
  settings?: JiraIssueSearchSettings | null | undefined;
  staticViewInput?: JiraIssueSearchStaticViewInput | null | undefined;
};
export type SaveResetViewSettingsButtonUIDiscardSettingsMutation$data = {
  readonly jira_discardUserIssueSearchConfig: {
    readonly errors: ReadonlyArray<{
      readonly extensions: {
        readonly errorType: string | null | undefined;
        readonly statusCode: number | null | undefined;
      } | null | undefined;
      readonly message: string | null | undefined;
    }> | null | undefined;
    readonly success: boolean;
    readonly view: {
      readonly jql?: string | null | undefined;
      readonly viewSettings?: {
        readonly groupByConfig: {
          readonly groupByField: {
            readonly fieldId: string | null | undefined;
          } | null | undefined;
        } | null | undefined;
        readonly hideDone: boolean | null | undefined;
      } | null | undefined;
    } | null | undefined;
  } | null | undefined;
};
export type SaveResetViewSettingsButtonUIDiscardSettingsMutation = {
  response: SaveResetViewSettingsButtonUIDiscardSettingsMutation$data;
  variables: SaveResetViewSettingsButtonUIDiscardSettingsMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "groupBy"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "input"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "issueSearchInput"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "settings"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "staticViewInput"
},
v5 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v6 = {
  "kind": "ScalarField",
  "name": "success"
},
v7 = {
  "kind": "ScalarField",
  "name": "jql"
},
v8 = {
  "kind": "InlineFragment",
  "selections": [
    (v7/*: any*/)
  ],
  "type": "JiraDetailedView"
},
v9 = [
  {
    "kind": "Variable",
    "name": "groupBy",
    "variableName": "groupBy"
  },
  {
    "kind": "Variable",
    "name": "issueSearchInput",
    "variableName": "issueSearchInput"
  },
  {
    "kind": "Variable",
    "name": "settings",
    "variableName": "settings"
  },
  {
    "kind": "Variable",
    "name": "staticViewInput",
    "variableName": "staticViewInput"
  }
],
v10 = {
  "kind": "ScalarField",
  "name": "fieldId"
},
v11 = {
  "kind": "ScalarField",
  "name": "hideDone"
},
v12 = {
  "kind": "ScalarField",
  "name": "message"
},
v13 = {
  "kind": "ScalarField",
  "name": "errorType"
},
v14 = {
  "kind": "ScalarField",
  "name": "statusCode"
},
v15 = {
  "kind": "ScalarField",
  "name": "__typename"
},
v16 = {
  "kind": "ScalarField",
  "name": "id"
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/)
    ],
    "kind": "Fragment",
    "name": "SaveResetViewSettingsButtonUIDiscardSettingsMutation",
    "selections": [
      {
        "args": (v5/*: any*/),
        "concreteType": "JiraDiscardUserIssueSearchConfigPayload",
        "kind": "LinkedField",
        "name": "jira_discardUserIssueSearchConfig",
        "plural": false,
        "selections": [
          (v6/*: any*/),
          {
            "kind": "LinkedField",
            "name": "view",
            "plural": false,
            "selections": [
              (v8/*: any*/),
              {
                "kind": "InlineFragment",
                "selections": [
                  (v7/*: any*/),
                  {
                    "args": (v9/*: any*/),
                    "concreteType": "JiraIssueSearchViewConfigSettings",
                    "kind": "LinkedField",
                    "name": "viewSettings",
                    "plural": false,
                    "selections": [
                      {
                        "concreteType": "JiraSpreadsheetGroupByConfig",
                        "kind": "LinkedField",
                        "name": "groupByConfig",
                        "plural": false,
                        "selections": [
                          {
                            "concreteType": "JiraField",
                            "kind": "LinkedField",
                            "name": "groupByField",
                            "plural": false,
                            "selections": [
                              (v10/*: any*/)
                            ]
                          }
                        ]
                      },
                      (v11/*: any*/)
                    ]
                  }
                ],
                "type": "JiraSpreadsheetView",
                "abstractKey": "__isJiraSpreadsheetView"
              }
            ]
          },
          {
            "concreteType": "MutationError",
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              (v12/*: any*/),
              {
                "kind": "LinkedField",
                "name": "extensions",
                "plural": false,
                "selections": [
                  (v13/*: any*/),
                  (v14/*: any*/)
                ]
              }
            ]
          }
        ]
      }
    ],
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/)
    ],
    "kind": "Operation",
    "name": "SaveResetViewSettingsButtonUIDiscardSettingsMutation",
    "selections": [
      {
        "args": (v5/*: any*/),
        "concreteType": "JiraDiscardUserIssueSearchConfigPayload",
        "kind": "LinkedField",
        "name": "jira_discardUserIssueSearchConfig",
        "plural": false,
        "selections": [
          (v6/*: any*/),
          {
            "kind": "LinkedField",
            "name": "view",
            "plural": false,
            "selections": [
              (v15/*: any*/),
              (v8/*: any*/),
              {
                "kind": "InlineFragment",
                "selections": [
                  (v7/*: any*/),
                  {
                    "args": (v9/*: any*/),
                    "concreteType": "JiraIssueSearchViewConfigSettings",
                    "kind": "LinkedField",
                    "name": "viewSettings",
                    "plural": false,
                    "selections": [
                      {
                        "concreteType": "JiraSpreadsheetGroupByConfig",
                        "kind": "LinkedField",
                        "name": "groupByConfig",
                        "plural": false,
                        "selections": [
                          {
                            "concreteType": "JiraField",
                            "kind": "LinkedField",
                            "name": "groupByField",
                            "plural": false,
                            "selections": [
                              (v10/*: any*/),
                              (v16/*: any*/)
                            ]
                          }
                        ]
                      },
                      (v11/*: any*/)
                    ]
                  }
                ],
                "type": "JiraSpreadsheetView",
                "abstractKey": "__isJiraSpreadsheetView"
              },
              (v16/*: any*/)
            ]
          },
          {
            "concreteType": "MutationError",
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              (v12/*: any*/),
              {
                "kind": "LinkedField",
                "name": "extensions",
                "plural": false,
                "selections": [
                  (v15/*: any*/),
                  (v13/*: any*/),
                  (v14/*: any*/),
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v16/*: any*/)
                    ],
                    "type": "BulkMutationErrorExtension"
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "id": "e8bfcb2fd4ca60cab5a228217932ed9db4d79fb1cdde8dfa6c2c662b15f0e3ec",
    "metadata": {},
    "name": "SaveResetViewSettingsButtonUIDiscardSettingsMutation",
    "operationKind": "mutation",
    "text": null
  }
};
})();

(node as any).hash = "07530cd995027111d1f5090a8420d18a";

export default node;
